import React from "react"

const Accessory = props => (
  <div className="PDP-Accessory">
    <img className="PDP-Accessory-Image" src={props.image} alt={props.device} />
    <div className="PDP-Accessory-Contents">
      <div className="PDP-Acessory-Line">
        <input className="PDP-Acessory-Checkbox" type="checkbox" />
        <h5>{props.device}</h5>
        <div />
        <span className="PDP-Acessory-Price">£{props.price}</span>
      </div>
    </div>
  </div>
)

export default Accessory
